import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslatedCellParams } from './translated-cell.model';

/**
 * @description
 * This component is used to translate the value of a cell in an ag-grid.
 * @usage
 * In your column definition, you can use this component as a cell renderer.
 * and pass the translation path as a parameter (don't forget to include the translation scope)
 * {
 *   field: 'example',
 *   cellRenderer: TranslatedCellComponent,
 *   cellRendererParams: {
 *     translationPath: 'translationScope.tableValues',
 *   }
 * }
 *
 * In your component/i18n/en-GB.json file, you need to have a key for each value
 * tableValues: {
 *   testA: 'Test A',
 *   testB: 'Test B',
 * }
 */

@Component({
  standalone: true,
  selector: 'rx-applications-translated-cell',
  template: `{{ keyAndTranslationPath | transloco }}`,
  imports: [CommonModule, TranslocoModule],
})
export class TranslatedCellComponent implements ICellRendererAngularComp {
  keyAndTranslationPath: string;

  agInit(params: TranslatedCellParams): void {
    if(!params || !params.value) {
      this.keyAndTranslationPath = '-';
      return;
    }
    this.keyAndTranslationPath = `${params.translationPath}.${params.value.toString().toLocaleLowerCase()}`
  }

  refresh(): boolean {
    return false;
  }
}
